import { render, staticRenderFns } from "./RelatorioComercial.vue?vue&type=template&id=d0de92a8"
import script from "./RelatorioComercial.vue?vue&type=script&lang=js"
export * from "./RelatorioComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports